import dateAtTime from './dateAtTime';
import dateOnly from './dateOnly';
import dateOnlyLong from './dateOnlyLong';
import dateTime from './dateTime';
import telephoneNumber from './telephoneNumber';

export default {
  dateAtTime,
  dateOnly,
  dateOnlyLong,
  dateTime,
  telephoneNumber,
};
